import React from 'react';
import { Redirect } from "react-router"; // optional
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import GoogleButton from 'react-google-button';
import { createStyles, makeStyles } from "@material-ui/core";
import * as firebase from "firebase/app";
var useStyles = makeStyles(function () {
    return createStyles({
        root: {
            marginTop: 16,
        },
        card: {},
        title: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 12,
        },
    });
});
export var LoginPage = function (_a) {
    var location = _a.location;
    var classes = useStyles();
    var provider = new firebase.auth.GoogleAuthProvider();
    return (React.createElement(Grid, { container: true, direction: "row", justify: "center", alignItems: "center", spacing: 10, className: classes.root },
        React.createElement(Grid, { item: true, xs: 11, lg: 7 },
            React.createElement(Card, { className: classes.card },
                React.createElement(CardContent, null,
                    React.createElement(Typography, { className: classes.title, color: "textSecondary", gutterBottom: true }, "Login with Google"),
                    React.createElement(GoogleButton, { onClick: function () { return firebase.auth().signInWithPopup(provider); } })))),
        React.createElement(Grid, { item: true, xs: 11, lg: 7 },
            React.createElement(Card, { className: classes.card },
                React.createElement(CardContent, null,
                    React.createElement(Typography, { className: classes.title, color: "textSecondary", gutterBottom: true }, "Login state"),
                    React.createElement("div", null, !firebase.auth().currentUser
                        ? React.createElement("span", null, "Not Logged in")
                        : React.createElement(Redirect, { to: location.state.from.pathname || '/' })))))));
};
//# sourceMappingURL=LoginPage.js.map